"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _obfuscateString = require("./obfuscate-string");
var deobfuscateString = function deobfuscateString() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (string.startsWith(_obfuscateString.prefix)) {
    var decoded = string.replace(_obfuscateString.prefix, '');
    if (typeof window !== 'undefined' && window.atob) {
      decoded = window.atob(decoded);
    } else {
      decoded = Buffer.from(decoded, 'base64').toString('ascii');
    }
    return decoded;
  }
  return string;
};
var _default = exports.default = deobfuscateString;